import { render } from "./DialogOkBtn.vue?vue&type=template&id=8a69db14"
import script from "./DialogOkBtn.vue?vue&type=script&lang=js"
export * from "./DialogOkBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__